module.exports = __webpack_public_path__ + "SMART-9e2ff9df809aa6a249b874059ba99c7c.png";